<template>
  <div class="flex justify-between">
    <p class="font-bold text-2xl pb-2 tracking-tight text-gray-900">
      {{ contractTitle }}
      <span v-if="product.title && product.price" class="text-base text-gray-500 font-normal mx-1 inline">
        | {{ product.title }} à {{ formatPrice(product.price) }}
      </span>
    </p>
  </div>
</template>

<script>
import { formatPrice } from "@estaly/ui";

export default {
  name: "InsuranceSaleTitle",

  props: {
    product: {
      type: Object,
      required: true,
    },
    contractType: {
      type: String,
      required: false,
      default: "insurance",
    },
  },

  computed: {
    contractTitle() {
      const titles = {
        insurance: "Vente d'un contrat d'assurance",
        warranty: "Vente d'un contrat de garantie",
      };

      return titles[this.contractType] || titles.insurance;
    },
  },

  methods: {
    formatPrice,
  },
};
</script>
